{{#if is_default}}
{{TR "Standardnutzer (explizite Freigabe)"}}
{{else}}
{{#unless users}}
--
{{/unless}}
{{#EACH-COLS users 1}}
	{{#if can_delete}}
	<a href="#" class="js-delete-group-user" data-group="{{../id}}" data-user="{{id}}">
		<i class="fa fa-trash"></i>
	</a>{{else}}
	{{/if}}&nbsp;<i class="fa fa-user"></i>&nbsp;{{name}} (<span><em class="email">{{email}}</em></span>)
{{/EACH-COLS}}
{{/if}}
